<template>
  <section
    id="card-text-alignment"
  >
    <b-overlay
      id="overlay-background"
      :show="loader || generalLoader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-row
        class="content-header"
      >
        <!-- Content Left -->
        <b-col
          class="content-header-left mb-2"
          cols="12"
          md="9"
        >
          <b-row class="breadcrumbs-top">
            <b-col cols="12">
              <h2 class="content-header-title float-left pr-1 mb-0">
                {{ $t('DEBTIA_VIEW_CASE') }}
              </h2>
              <div class="breadcrumb-wrapper">
                <b-breadcrumb>
                  <b-breadcrumb-item to="/cases">
                    <feather-icon
                      icon="HomeIcon"
                      size="16"
                      class="align-text-top"
                    />
                  </b-breadcrumb-item>
                  <b-breadcrumb-item active>
                    {{ caseDetailsData.id }} (BC-ID: {{ caseDetailsData.bc_case_id }})
                  </b-breadcrumb-item>
                </b-breadcrumb>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- static actions start-->
      <b-col
        v-if="!isBlur"
        md="12"
        lg="12"
      >
        <b-card
          v-if="caseDetailsData.status === 0 || caseDetailsData.status === null"
          :class="caseDetailsData.status === 0 ? 'case-general-info-blue' : 'case-general-info-red'"
        >
          <b-row>
            <b-col
              class="text-left"
              md="6"
              lg="6"
            >
              <h6>
                BC CASE ID: <span class="code text-red">{{ caseDetailsData.bc_case_id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-bc-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-bc-case-id"
                  type="hidden"
                  :value="caseDetailsData.bc_case_id"
                >
              </h6>
              <h6 class="mb-0">
                CASE ID: <span class="code text-red">{{ caseDetailsData.prefix_case_id ? caseDetailsData.prefix_case_id : caseDetailsData.id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-case-id"
                  type="hidden"
                  :value="caseDetailsData.id"
                >
              </h6>
            </b-col>
            <b-col
              class="text-right"
              md="6"
              lg="6"
            >
              <!-- left align -->
              <b-button-group
                class="my-1"
              >
                <b-button
                  v-if="$ability.can(constants.action.permissionCaseProcessChange, constants.resource.user) && user_type !== 'super-admin'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-change-case-process
                  variant="outline-primary"
                  class="mr-1"
                >
                  {{ $t('DEBTIA_CHANGE_PROCESS') }}
                </b-button>
                <b-button
                  v-if="$ability.can(constants.action.permissionGenerateAgreementPlan, constants.resource.user) && user_type !== 'super-admin' && (installmentplanstatus === 0 || installmentplanstatus === 404)"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-prevent-closing
                  variant="outline-primary"
                  class="mr-1"
                  @click="openGenerateAgreementForm"
                >
                  {{ $t('DEBTIA_AGREEMENT_LINK') }}
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1"
                  @click="debtCaseAction(caseDetailsData.id , 1)"
                >
                  {{ $t('DEBTIA_ACCEPT_CASE') }}
                </b-button>
                <!-- center align -->
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-case
                  variant="outline-danger"
                  @click="getDebtCaseActionData(caseStateData, 'decline')"
                >
                  {{ $t('DEBTIA_DECLINE_CASE') }}
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card
          v-if="caseDetailsData.status === 1 || caseDetailsData.status === 4"
          :class="`text-right ${caseDetailsData.status === 1 ? 'case-general-info-green' : 'case-general-info-orange'}`"
        >
          <b-row>
            <b-col
              class="text-left"
              md="3"
              lg="3"
            >
              <h6>
                BC CASE ID: <span class="code text-red">{{ caseDetailsData.bc_case_id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-bc-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-bc-case-id"
                  type="hidden"
                  :value="caseDetailsData.bc_case_id"
                >
              </h6>
              <h6 class="mb-0">
                CASE ID: <span class="code text-red">{{ caseDetailsData.prefix_case_id ? caseDetailsData.prefix_case_id : caseDetailsData.id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-case-id"
                  type="hidden"
                  :value="caseDetailsData.id"
                >
              </h6>
            </b-col>
            <b-col
              class="text-right"
              md="9"
              lg="9"
            >
              <!-- center align -->
              <b-button-group>
                <b-button
                  v-if="$ability.can(constants.action.permissionCaseProcessChange, constants.resource.user) && user_type !== 'super-admin'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-change-case-process
                  variant="outline-primary"
                  class="mr-1"
                >
                  {{ $t('DEBTIA_CHANGE_PROCESS') }}
                </b-button>
                <b-button
                  v-if="$ability.can(constants.action.permissionGenerateAgreementPlan, constants.resource.user) && user_type !== 'super-admin' && (installmentplanstatus === 0 || installmentplanstatus === 404)"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-prevent-closing
                  variant="outline-primary"
                  class="mr-1"
                  @click="openGenerateAgreementForm"
                >
                  {{ $t('DEBTIA_AGREEMENT_LINK') }}
                </b-button>
                <b-button
                  v-if="state != 'pause'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-case
                  variant="outline-primary"
                  class="mr-1"
                  @click="getDebtCaseActionData(caseStateData, 'pause')"
                >
                  {{ $t('DEBTIA_PAUSE_CASE') }}
                </b-button>
                <!-- center align -->
                <b-button
                  v-if="state === 'pause'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-case
                  variant="outline-success"
                  class="mr-1"
                  @click="getDebtCaseActionData(caseStateData, 'resume')"
                >
                  {{ $t('DEBTIA_RESUME_CASE') }}
                </b-button>
                <!-- left align -->
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-case
                  variant="outline-danger"
                  @click="getDebtCaseActionData(caseStateData, 'terminate')"
                >
                  {{ $t('DEBTIA_TERMINATE_CASE') }}
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card
          v-if="caseDetailsData.status === 2"
          class="text-right case-general-info-red"
        >
          <b-row>
            <b-col
              class="text-left"
              md="6"
              lg="6"
            >
              <h6>
                BC CASE ID: <span class="code text-red">{{ caseDetailsData.bc_case_id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-bc-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-bc-case-id"
                  type="hidden"
                  :value="caseDetailsData.bc_case_id"
                >
              </h6>
              <h6 class="mb-0">
                CASE ID: <span class="code text-red">{{ caseDetailsData.prefix_case_id ? caseDetailsData.prefix_case_id : caseDetailsData.id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-case-id"
                  type="hidden"
                  :value="caseDetailsData.id"
                >
              </h6>
            </b-col>
            <b-col
              class="text-right"
              md="6"
              lg="6"
            >
              <!-- left align -->
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-case
                variant="outline-danger"
                class="mr-1"
              >
                {{ $t('DEBTIA_DECLINED') }}
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col
        v-else-if="isBlur"
        md="12"
        lg="12"
      >
        <b-card
          v-if="caseDetailsData.status === 2"
        >
          <h6
            id="popover-reactive-4"
            ref="button"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="transaction-title pointer-name"
            @mouseover="setStatePopup(caseStateData)"
          >
            {{ $t('DEBTIA_DECLINED') }}
          </h6>
          <div><small>{{ caseStateData.reason }}</small></div>
        </b-card>
        <b-card
          v-if="caseDetailsData.status === 3"
          class="text-right case-general-info-red"
        >
          <b-row>
            <b-col
              class="text-left"
              md="6"
              lg="6"
            >
              <h6>
                BC CASE ID: <span class="code text-red">{{ caseDetailsData.bc_case_id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-bc-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-bc-case-id"
                  type="hidden"
                  :value="caseDetailsData.bc_case_id"
                >
              </h6>
              <h6 class="mb-0">
                CASE ID: <span class="code text-red">{{ caseDetailsData.prefix_case_id ? caseDetailsData.prefix_case_id : caseDetailsData.id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-case-id"
                  type="hidden"
                  :value="caseDetailsData.id"
                >
              </h6>
            </b-col>
            <b-col
              class="text-right"
              md="6"
              lg="6"
            >
              <b-button
                v-if="$ability.can(constants.action.permissionCaseProcessChange, constants.resource.user) && user_type !== 'super-admin'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-change-case-process
                variant="outline-primary"
                class="mr-1 display-inline"
              >
                {{ $t('DEBTIA_CHANGE_PROCESS') }}
              </b-button>
              <h6
                id="popover-reactive-4"
                ref="button"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="transaction-title pointer-name display-inline"
                @mouseover="setStatePopup(caseStateData)"
              >
                {{ $t('DEBTIA_TERMINATED') }}
              </h6>
              <div><small>{{ caseStateData.reason }}</small></div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!-- static actions ends-->
      <hr>
      <!-- current progress starts -->
      <b-row
        v-if="caseProcessesCompleted"
      >
        <b-col sm="12">
          <b-card
            class="processcompletedmessage"
          >
            <b-alert
              variant="primary"
              class="processcompletedmessagealert"
              show
            >
              <div class="alert-body">
                <span>{{ $t('DEBTIA_PROCESS_COMPLETED') }}</span>
              </div>
            </b-alert>
          </b-card>
        </b-col>
      </b-row>
      <b-row
        v-else
      >
        <b-col
          v-if="caseData.process_data"
          sm="4"
        >
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              {{ $t('DEBTIA_CURRENT_MODULE') }}
            </b-list-group-item>
            <b-list-group-item
              v-if="!loader"
              href="#"
            >
              {{ caseData.process_data.active_module.module_title ? caseData.process_data.active_module.module_title : 'N/A' }}
              {{ caseData.process_data.active_module.module_id === 1 ? `(${caseData.process_data.active_module.module_settings.awaitedDays} ${$t('DEBTIA_DAYS_LEFT')})` : '' }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col
          v-if="caseData.process_data"
          sm="4"
        >
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              {{ $t('DEBTIA_NEXT_MODULE') }}
            </b-list-group-item>
            <b-list-group-item
              v-if="!loader"
              href="#"
            >
              {{ caseData.process_data.next_module.module_title ? caseData.process_data.next_module.module_title : 'N/A' }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="4">
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              {{ $t('DEBTIA_PROCESSES') }}
            </b-list-group-item>
            <div
              v-for="(data,index) in caseData.process_cases"
              :key="index"
            >
              <b-list-group-item :href="`/process/view/${data.process_id}`">
                {{ data.title }}
              </b-list-group-item>
            </div>
          </b-list-group>
        </b-col>
        <b-col
          v-if="caseData.userActions && isInstallmentPlanCompleted === 1"
          sm="4"
          class="user-action-buttons"
        >
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              User Action Buttons
            </b-list-group-item>
            <b-list-group-item
              v-if="caseData.userActions.await"
            >
              <strong>{{ $t('DEBTIA_AWAIT_DAYS_LEFT').replace('X', caseData.userActions.await_days) }}</strong>
            </b-list-group-item>
            <b-list-group-item>
              <strong>Description: </strong> {{ caseData.userActions.description }}
            </b-list-group-item>
            <b-list-group-item
              v-if="debt_case_state && debt_case_state.state === 'pause'"
            >
              <b-alert
                variant="warning"
                show
              >
                <div class="alert-body">
                  <span>This case is put in pause by {{ debt_case_state.employee_name }} until {{ getFormatedDate(debt_case_state.pause_date) }} because of {{ debt_case_state.description }}.</span>
                </div>
              </b-alert>
            </b-list-group-item>
            <b-list-group-item
              v-else-if="caseData.userActions.recipient === 'client'"
            >
              <template v-for="(data, index) in caseData.userActions.buttons">
                <b-button
                  v-if="!data.await"
                  :key="index"
                  v-b-modal.user-action-modal
                  :variant="getBtnVariant(data.button_color)"
                  class="user-action-button"
                  @click="actionBtnClicked(data.id, caseData.userActions.process_id)"
                >
                  {{ data.button_title }}
                </b-button>
              </template>
            </b-list-group-item>
            <b-list-group-item
              v-else
            >
              <template v-for="(data, index) in caseData.userActions.buttons">
                <b-button
                  v-if="!data.await"
                  :key="index"
                  :variant="getBtnVariant(data.button_color)"
                  class="user-action-button"
                  @click="userActionButtonClicked(data.id, caseData.userActions.process_id)"
                >
                  {{ data.button_title }}
                </b-button>
              </template>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <!-- current progress ends -->
      <hr>
      <b-row
        v-if="customVariables.length > 0"
      >
        <b-col
          sm="12"
        >
          <case-custom-variables
            :variables="customVariables"
            :airports="customVariableAirports"
            :get-details="getDetails"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="7"
          lg="7"
        >
          <b-row>
            <b-col
              sm="12"
              md="12"
              lg="12"
            >
              <b-card
                :id="`debt-statements`"
              >
                <b-card-header
                  class="base-document-header"
                >
                  <b-card-title>{{ $t('DEBTIA_STATEMENTS') }}</b-card-title>
                  <b-card-title
                    v-if="$ability.can(constants.action.permissionEditStatements, constants.resource.user) && (caseDetailsData.status === 1 || caseDetailsData.status === 4)"
                    class="text-primary"
                  >
                    <b-button
                      id="edit-statements"
                      v-b-modal.modal-edit-statements
                      variant="primary"
                      @click="changeBtn()"
                    >
                      <span class="text-nowrap">{{ $t('DEBTIA_CHANGE_STATEMENT') }}</span>
                    </b-button>
                  </b-card-title>
                </b-card-header>
                <!-- <b-table
                :fields="statementsTableFields"
                :items="statementsData"
                striped
                responsive
              >
                <template #cell(category)="row">
                  <b-form-checkbox
                    v-model="row.detailsShowing"
                    plain
                    class="vs-checkbox-con"
                    v-if="row.item.category !== 'SUM'"
                    @change="row.toggleDetails"
                  >
                    {{ row.item.category }}
                  </b-form-checkbox>
                  <div v-else>
                    {{ row.item.category }}
                  </div>
                </template>
                <template #row-details="row">
                  <b-table
                    :fields="statementBaseDocumentsTableFields"
                    :items="row.item.documents"
                    striped
                    responsive
                    thead-class="d-none"
                  >
                    <template #cell(file_link)="data">
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="flat-primary"
                        @click="openLink(data.item.file_link)"
                      >
                        {{ data.item.file_link }}
                      </b-button>
                    </template>
                  </b-table> -->

                <b-table
                  :fields="statementsTableFields"
                  :items="statementsData"
                  striped
                  responsive
                  table-class="parent-table"
                >
                  <template #cell(category)="row">
                    <b-link
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      @click="row.toggleDetails"
                    >
                      {{ ($i18n.locale === 'en') ? row.item.en_name : row.item.da_name }}
                    </b-link>
                  </template>
                  <template #row-details="row">
                    <b-table
                      :fields="statementCostDocumentsTableFields"
                      :items="row.item.costDocuments"
                      striped
                      responsive
                      thead-class="d-none"
                      table-class="child-table"
                    >
                      <template #cell(jobTaskNo)="cost">
                        <b-link
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="flat-primary"
                          @click="cost.toggleDetails"
                        >
                          {{ ($i18n.locale === 'en') ? cost.item.en_name : cost.item.da_name }}
                        </b-link>
                      </template>
                    </b-table>
                  </template>
                  <template #cell(avatar)="data">
                    <b-avatar :src="data.value" />
                  </template>

                  <template #cell(status)="data">
                    <b-badge :variant="status[1][data.value]">
                      {{ status[0][data.value] }}
                    </b-badge>
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              sm="12"
              md="12"
              lg="12"
            >
              <b-overlay
                id="overlay-background-documents"
                :show="documentLoader"
                variant="dark"
                opacity="0.85"
                blur="2px"
                rounded="sm"
                spinner-variant="primary"
                spinner-medium
              >
                <b-card>
                  <b-card-header
                    class="base-document-header"
                  >
                    <b-card-title>{{ $t('DEBTIA_DOCUMENTS') }}</b-card-title>
                    <b-card-title class="text-primary">
                      <b-button
                        id="add-case-btn"
                        v-b-modal.modal-add-other-files
                        variant="primary"
                      >
                        <span class="text-nowrap">{{ $t('DEBTIA_ADD_FILES') }}</span>
                      </b-button>
                    </b-card-title>
                  </b-card-header>
                  <b-card-header
                    class="base-document-header"
                  >
                    <b-button-group
                      size="sm"
                    >
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        :class="baseDocumentType === 1 ? 'base-document-active-btn' : ''"
                        @click="baseDocumentType = 1"
                      >
                        {{ $t('DEBTIA_ALL') }}
                      </b-button>
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        :class="baseDocumentType === 2 ? 'base-document-active-btn' : ''"
                        @click="baseDocumentType = 2"
                      >
                        {{ $t('DEBTIA_UPLOADED') }}
                      </b-button>
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        :class="baseDocumentType === 3 ? 'base-document-active-btn' : ''"
                        @click="baseDocumentType = 3"
                      >
                        {{ $t('DEBTIA_PROCESSED') }}
                      </b-button>
                    </b-button-group>
                  </b-card-header>
                  <!-- client documents starts -->
                  <b-table
                    ref="roles"
                    :fields="documentsTableFields"
                    :items="allBaseDocuments"
                    striped
                    responsive
                    show-empty
                  >
                    <template #head(checkbox)="">
                      <b-form-checkbox
                        id="main_checkbox"
                        v-model="header_check"
                      />
                    </template>
                    <template #empty="">
                      <p>{{ $t('DEBTIA_NO_RECORD_FOUND') }}</p>
                    </template>
                    <template #cell(checkbox)="data">
                      <b-form-checkbox
                        :id="`checkbox_${data.item.id}`"
                        v-model="baseDocumentVariables[`checkbox_${data.item.id}`].check"
                        @change="baseDocumentCheckBoxClicked($event, data.item.id)"
                      />
                    </template>
                    <template #cell(category)="data">
                      {{ data.item.category ? data.item.category : data.item.template_name }}
                    </template>
                    <template #cell(file_link)="data">
                      <feather-icon
                        icon="ExternalLinkIcon"
                        @click="openLink(data.item.file_link)"
                      />
                    </template>
                    <template #cell(interest_rate_percentage)="data">
                      <div v-if="data.item.category == 'base documents'">
                        {{ (data.item.interest_rate_agreed) ? data.item.interest_rate_percentage + '%' : data.item.default_interest_rate + '% standard process rente' }}
                      </div>
                      <div v-else>
                        -
                      </div>
                    </template>

                    <template #cell(action)="data">
                      <b-button
                        v-if="$ability.can(constants.action.permissionDeleteDebtCaseFile, constants.resource.user) && data.item.category != 'Base Documents' && data.item.category != 'Credit Notes' && data.item.category != 'Debt Reminders' && !data.item.processedLettersCheck"
                        variant="gradient-danger"
                        class="btn-icon padding-1"
                        @click="confirmDeleteDocument(data.item.id, data.item.title, data.item.file_link)"
                      >
                        <feather-icon
                          icon="XIcon"
                        />
                      </b-button>
                    </template>
                    <!-- <template #cell(action)="data"> -->
                    <!-- <feather-icon
                      v-b-modal.modal-case-edit
                      icon="ExternalLinkIcon"
                      @click="caseDetails(data.item.id)"
                    /> -->
                    <!-- <b-link
                      :to="{ name: 'case-details', params: { id: data.item.id } }"
                      class="margin-right: 15px; font-weight-bold d-block text-nowrap"
                    >
                      <feather-icon
                        icon="EyeIcon"
                      />
                    </b-link> -->
                    <!-- <feather-icon
                      icon="Trash2Icon"
                      style="color: #ff3737;"
                      @click="confirmDeleteText(data.item.id,data.item.name)"
                    /> -->
                    <!-- </template> -->
                  </b-table>
                  <div>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      v-b-modal.base-documents-modal
                      variant="primary"
                      class="document-buttons"
                      size="sm"
                      :disabled="allBaseDocuments.length === 0"
                      @click="downloadAllFiles(), checkAll = true"
                    >
                      {{ $t('DEBTIA_DOWNLOAD_ALL_FILES') }}
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      v-b-modal.base-documents-modal
                      variant="primary"
                      class="document-buttons"
                      size="sm"
                      :disabled="allBaseDocuments.length === 0 || selectedBaseDocuments.length === 0"
                      @click="downloadSelectedFiles(), checkAll = false"
                    >
                      {{ $t('DEBTIA_DOWNLOAD_SELECTED_FILES') }}
                    </b-button>
                    <b-button
                      v-if="$ability.can(constants.action.permissionDeleteDebtCaseFile, constants.resource.user)"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="danger"
                      class="document-buttons"
                      size="sm"
                      :disabled="allBaseDocuments.length === 0 || selectedDeletableDocuments.length === 0"
                      @click="deleteConfirmationPopup"
                    >
                      {{ $t('DEBTIA_DELETE_SELECTED_FILES') }}
                    </b-button>
                  </div>
                </b-card>
              </b-overlay>
            </b-col>
          </b-row>
          <!-- case documents ends -->
          <!-- case payments starts -->
          <b-row>
            <b-col
              md="12"
              xl="12"
            >
              <b-card
                :title="$t('DEBTIA_PAYMENTS')"
              >
                <b-table
                  v-if="paymentsData.length > 0"
                  :fields="paymentsTableFields"
                  :items="paymentsData"
                  striped
                  responsive
                >
                  <template #cell(id)="row">
                    <b-link
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      @click="row.toggleDetails"
                    >
                      {{ row.item.id }}
                    </b-link>
                  </template>
                  <!-- <template #row-details="row">
                    <b-table
                      :fields="paymentsDataTableFields"
                      :items="row.item.documents"
                      striped
                      responsive
                    >
                      <template #cell(file_link)="data">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="flat-primary"
                          @click="openLink(data.item.file_link)"
                        >
                          {{ data.item.file_link }}
                        </b-button>
                      </template>
                    </b-table>
                  </template> -->
                </b-table>
                <b-alert
                  v-else
                  variant="warning"
                  show
                >
                  <div class="alert-body">
                    {{ $t('DEBTIA_NO_PAYMENTS_MSG') }}
                  </div>
                </b-alert>
              </b-card>
            </b-col>
          </b-row>
          <!-- case payments end -->
          <!-- case installment starts -->
          <b-row>
            <b-col
              md="12"
              xl="12"
            >
              <b-overlay
                id="overlay-background"
                :show="installmentloader"
                variant="dark"
                opacity="0.85"
                blur="2px"
                rounded="sm"
                spinner-variant="primary"
                spinner-medium
              >
                <b-card>
                  <b-card-header
                    class="installment-plan-header"
                  >
                    <b-card-title>{{ $t('DEBTIA_INSTALLMENT_PLAN') }}</b-card-title>
                    <b-button
                      v-if="$ability.can(constants.action.permissionCancelAgreementPlan, constants.resource.user) && !isSuperAdmin && installmentplanstatus === 1 && installmentData.length > 0"
                      id="cancel-plan-btn"
                      variant="primary"
                      @click="confirmText"
                    >
                      <span class="text-nowrap">{{ $t('DEBTIA_CANCEL_PLAN') }}</span>
                    </b-button>
                  </b-card-header>
                  <b-card-body
                    class="installment-plan-body"
                  >
                    <b-table
                      v-if="installmentData.length > 0"
                      :fields="installmentTableFields"
                      :items="installmentData"
                      striped
                      responsive
                    >
                      <template #cell(amount)="row">
                        {{ `${formatCurrency(row.item.installment_amount, defaultCurrency)}` }}
                      </template>
                      <template #cell(interest)="row">
                        {{ `${formatCurrency(row.item.interest, defaultCurrency)}` }}
                      </template>
                      <template #cell(remaining_amount)="row">
                        {{ `${formatCurrency(row.item.remaining_amount, defaultCurrency)}` }}
                      </template>
                      <template #cell(status)="row">
                        <b-badge
                          :variant="row.item.is_paid ? 'success' : 'warning'"
                          class="badge-glow"
                        >
                          {{ row.item.is_paid ? $t('DEBTIA_PAID') : $t('DEBTIA_NOT_PAID') }}
                        </b-badge>
                      </template>
                      <!-- <template #row-details="row">
                        <b-table
                          :fields="paymentsDataTableFields"
                          :items="row.item.documents"
                          striped
                          responsive
                        >
                          <template #cell(file_link)="data">
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              variant="flat-primary"
                              @click="openLink(data.item.file_link)"
                            >
                              {{ data.item.file_link }}
                            </b-button>
                          </template>
                        </b-table>
                      </template> -->
                    </b-table>
                    <b-alert
                      v-else
                      variant="warning"
                      show
                    >
                      <div class="alert-body">
                        {{ $t('DEBTIA_NO_PLAN_GENERATED_MSG') }}
                      </div>
                    </b-alert>
                  </b-card-body>
                </b-card>
              </b-overlay>
            </b-col>
          </b-row>
          <!-- case installments end -->

          <!-- case paid invoices starts -->
          <b-row>
            <b-col
              md="12"
              xl="12"
            >
              <b-card
                :title="$t('DEBTIA_PAID_INVOICES')"
              >
                <b-table
                  v-if="invoicesData.length > 0"
                  :fields="invoicesTableFields"
                  :items="invoicesData"
                  striped
                  responsive
                >
                  <template #cell(file_link)="data">
                    <feather-icon
                      icon="ExternalLinkIcon"
                      @click="openLink(data.item.file_link)"
                    />
                  </template>
                  <template #cell(sub_total)="data">
                    {{ `${formatCurrency(data.item.sub_total, defaultCurrency)}` }}
                  </template>
                  <template #cell(vat_amount)="data">
                    {{ `${formatCurrency(data.item.vat_amount, defaultCurrency)}` }}
                  </template>
                  <template #cell(total_amount)="data">
                    {{ `${formatCurrency(data.item.total_amount, defaultCurrency)}` }}
                  </template>
                </b-table>
                <b-alert
                  v-else
                  variant="warning"
                  show
                >
                  <div class="alert-body">
                    {{ $t('DEBTIA_NO_INVOICES_MSG') }}
                  </div>
                </b-alert>
              </b-card>
            </b-col>
          </b-row>
          <!-- case payments end -->
        </b-col>
        <b-col
          sm="12"
          md="5"
          lg="5"
        >
          <!-- show debtor, representative and client widget starts -->
          <b-row
            v-if="caseData.length !== 0"
          >
            <!-- solid color -->
            <b-col
              md="12"
              xl="12"
            >
              <b-card
                v-if="caseData.length !== 0"
                class="card-transaction"
                no-body
              >
                <b-card-header>
                  <b-card-title>{{ $t('DEBTIA_CLIENT') }}</b-card-title>
                  <b-card-title class="text-primary">
                    <b-button
                      id="add-case-btn"
                      v-b-modal.modal-change-client
                      variant="primary"
                    >
                      <span class="text-nowrap">{{ $t('DEBTIA_CHANGE') }}</span>
                    </b-button>
                  </b-card-title>
                </b-card-header>

                <b-card-body
                  v-if="caseData.client"
                  class="casedetails-card-body"
                >
                  <div
                    class="transaction-item"
                  >
                    <b-media no-body>
                      <b-media-aside>
                        <b-avatar
                          rounded
                          size="42"
                          variant="light-primary"
                        >
                          <feather-icon
                            v-if="!loader"
                            size="18"
                            :icon="caseData.client.type === 'person' ? 'UserIcon' : 'HomeIcon'"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body
                        v-if="!loader"
                      >
                        <h6
                          id="popover-reactive-1"
                          ref="button"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          class="transaction-title pointer-name"
                          @mouseover="setpopup(caseData.client)"
                        >
                          <b-link
                            :to="{ name: 'client-view', params: { id: caseData.client.id } }"
                            target="_blank"
                          >{{ (caseData.client.name) ? caseData.client.name : 'clientName' }}
                          </b-link>
                        </h6>
                        <div><small>{{ caseData.client.contact_person }}</small></div>
                        <div><small>{{ caseData.client.address.place }}</small></div>
                      </b-media-body>
                    </b-media>
                  </div>
                </b-card-body>
                <b-card-header>
                  <b-card-title>{{ $t('DEBTIA_DEBTORS') }}</b-card-title>
                  <b-card-title class="text-primary">
                    <b-button
                      id="add-case-btn"
                      v-b-modal.modal-change-debtors
                      variant="primary"
                    >
                      <span class="text-nowrap">{{ $t('DEBTIA_CHANGE') }}</span>
                    </b-button>
                  </b-card-title></b-card-header>

                <b-card-body
                  class="casedetails-card-body"
                >
                  <div
                    v-for="(data,index) in caseData.debtors"
                    :key="index"
                    class="transaction-item"
                  >
                    <b-media no-body>
                      <b-media-aside v-if="data.isMainDebtor === true">
                        <div
                          class="star-icon-box"
                        >
                          <b-avatar
                            rounded
                            size="42"
                            variant="light-primary"
                          >
                            <div
                              class="star"
                            />
                            <feather-icon
                              size="
                              18"
                              :icon="data.debtor_type === 'person' ? 'UserIcon' : 'HomeIcon'"
                            />
                          </b-avatar>
                        </div>
                      </b-media-aside>
                      <b-media-aside v-else>
                        <b-avatar
                          rounded
                          size="42"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="
                              18"
                            :icon="data.debtor_type === 'person' ? 'UserIcon' : 'HomeIcon'"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body>
                        <h6
                          :id="'popover-reactive-debtor-'+data.id"
                          ref="button"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          :to="{ name: 'debtor-view', params: { id: data.id } }"
                          class="transaction-title pointer-name"
                          @mouseover="setdebtorpopup(data)"
                        >
                          <b-link
                            :to="{ name: 'debtor-view', params: { id: data.id } }"
                            target="_blank"
                          >{{ (data.name) ? data.name : 'debtorName' }}
                          </b-link>
                        </h6>
                        <div><small>{{ data.contact_person }}</small></div>
                        <div><small>{{ data.address.place }}</small></div>
                        <div
                          v-if="data.representative !== null"
                          class="representative-div"
                        >
                          <b-badge variant="primary">
                            {{ $t('DEBTIA_REPRESENTATIVE') }}
                          </b-badge>
                          <h6
                            :id="'popover-reactive-representative-'+data.id"
                            ref="button"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="transaction-title pointer-name"
                            @mouseover="setrepresentativepopup(data.representative)"
                          >
                            {{ (data.representative.name) ? data.representative.name : 'representativeName' }}
                          </h6>
                          <div
                            v-if="data.representative !== null"
                          ><small>{{ data.representative.company }}</small></div>
                          <div
                            v-if="data.representative !== null"
                          ><small>{{ data.representative.phone }}</small></div>
                        </div>
                      </b-media-body>
                    </b-media>
                  </div>
                </b-card-body>
              </b-card>

            </b-col>
          </b-row>
          <!-- show debtor, representative and client widget ends -->
          <b-row>
            <b-col>
              <b-overlay
                id="overlay-background"
                :show="notesbusy"
                variant="dark"
                opacity="0.85"
                blur="2px"
                rounded="sm"
                spinner-variant="primary"
                spinner-medium
              >
                <b-card
                  :title="$t('DEBTIA_ADD_NOTES')"
                >
                  <b-form>
                    <validation-observer
                      ref="addnotesform"
                      tag="form"
                    >
                      <b-row>
                        <b-col
                          sm="12"
                        >
                          <b-form-group
                            label-for="notes"
                            class="mb-1"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Notes"
                              rules="required"
                            >
                              <quill-editor
                                v-model="notestext"
                                :options="snowOption"
                                style="min-height: 150px"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          sm="12"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_NOTE_VISIBLE_FOR')"
                            label-for="notes-roles"
                            class="mb-2"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Roles"
                              rules="required"
                            >
                              <v-select
                                id="notes-roles"
                                v-model="selectedRoles"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                multiple
                                label="label"
                                :options="noteRoles"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                          <b-button
                            class="notesSubmitBtn"
                            size="md"
                            variant="primary"
                            type="submit"
                            @click.prevent="notesfieldsfilled"
                          >
                            <span>{{ $t('DEBTIA_SUBMIT') }}</span>
                          </b-button>
                        </b-col>
                      </b-row>
                    </validation-observer>
                  </b-form>
                  <b-alert
                    v-if="showNotesAlert"
                    variant="primary"
                    class="notes-alert"
                    show
                  >
                    <div class="alert-body">
                      <span>{{ $t('DEBTIA_NOTE_ADDED_SUCCESS') }}</span>
                    </div>
                  </b-alert>
                </b-card>
              </b-overlay>
            </b-col>
          </b-row>
          <b-card
            :title="$t('DEBTIA_CASE_LOGS_HISTORY')"
          >
            <!-- search here -->
            <b-form-group>
              <b-input-group>
                <b-form-input
                  id="search"
                  v-model="searchQuery"
                  :placeholder="$t('DEBTIA_SEARCH')"
                  @keyup.enter="getCaseLogsData()"
                />
                <b-input-group-append>
                  <b-button variant="outline-primary">
                    <feather-icon
                      icon="FilterIcon"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <div
              v-for="(data,cldindex) in caseLogsData"
              :key="cldindex"
              class="mt-2"
            >
              <div
                v-if="data.type === 'Debt Case Notes'"
              >
                <b-card
                  v-if="canshow(data.content)"
                  class="border mb-0"
                >
                  <b-card-text class="card-text content-heading mb-35">
                    <h4>
                      {{ $t('DEBTIA_DEBT_CASE_NOTES') }}
                    </h4>  <p style="float: right">
                      {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                    </p>
                  </b-card-text>
                  <div class="border mb-10 padding-content">
                    <div
                      class="business-item"
                    >
                      <div class="d-flex align-items-center justify-content-between">
                        <label
                          class="note-font"
                          v-html="data.note"
                        />
                        <b-badge variant="light-primary">
                          <b-button
                            :id="'notes-popover-reactive-'+data.id"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="btn-icon"
                          >
                            <feather-icon icon="EyeIcon" />
                          </b-button>
                          <b-popover
                            ref="popover"
                            :target="'notes-popover-reactive-'+data.id"
                            triggers="hover"
                            placement="auto"
                            container="my-container"
                          >
                            <template #title>
                              <div class="d-flex justify-content-between align-items-center">
                                <span>{{ $t('DEBTIA_ALLOWED_ROLES') }}</span>
                              </div>
                            </template>
                            <div>
                              <b-card
                                border-variant="primary"
                                bg-variant="transparent"
                                class="shadow-none"
                              >
                                <b-card-text v-if="data.content.length > 0">
                                  <h6
                                    v-for="(role ,roleindex) in JSON.parse(data.content)"
                                    :key="roleindex"
                                  >&#8226; {{ role }} </h6>
                                </b-card-text>
                              </b-card>
                            </div>
                          </b-popover>
                        </b-badge>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
              <div
                v-else-if="data.type === 'Email'"
              >
                <b-card
                  class="border mb-0"
                >
                  <b-card-text class="card-text content-heading mb-35">
                    <p style="float: right">
                      {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                    </p>
                  </b-card-text>
                  <div class="border mb-10 padding-content">
                    <div
                      class="business-item"
                    >
                      <div class="d-flex align-items-center justify-content-between">
                        <label
                          class="note-font"
                        >From: {{ data.sender }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="border mb-10 padding-content">
                    <div
                      class="business-item"
                    >
                      <div class="d-flex align-items-center justify-content-between">
                        <label
                          class="note-font"
                        >To: {{ data.receiver != null ? JSON.parse(data.receiver).to : '' }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="border mb-10 padding-content">
                    <div
                      class="business-item"
                    >
                      <div class="d-flex align-items-center justify-content-between">
                        <label
                          class="note-font"
                        >Subject: {{ data.subject }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="border mb-10 padding-content">
                    <div
                      class="business-item"
                    >
                      <div
                        style="overflow-y: hidden"
                      >
                        <label
                          class="note-font"
                          v-html="(data.isOpen === true) ? data.body : data.body.substr(0, 150)"
                        />
                        <b-button
                          v-if="data.isOpen === false"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          class="edit-client-btn"
                          @click="setStrLimit(data.id, 'more')"
                        >
                          {{ $t("DEBTIA_VIEW_MORE") }}
                          <feather-icon
                            icon="ChevronDownIcon"
                          />
                        </b-button>
                        <b-button
                          v-if="data.isOpen === true"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          class="edit-client-btn"
                          @click="setStrLimit(data.id, 'less')"
                        >
                          {{ $t("DEBTIA_VIEW_LESS") }}
                          <feather-icon
                            icon="ChevronUpIcon"
                          />
                        </b-button>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="data.attachments != null && data.attachments.length > 0 && data.attachments !== '[]'"
                    class="border mb-10 padding-content"
                  >
                    <div
                      class="business-item"
                    >
                      <div
                        class="d-flex flex-column"
                      >
                        <b-link
                          v-for="(value, index) in JSON.parse(data.attachments)"
                          :key="index"
                          :href="value"
                          target="_blank"
                          :class="{'mt-75': index}"
                        >
                          <span class="text-muted font-weight-bolder align-text-top">{{ value.substring(value.lastIndexOf("/")+1) }} <feather-icon
                            icon="ExternalLinkIcon"
                          /></span>
                        </b-link>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
              <div
                v-else-if="data.type === 'Letter'"
              >
                <b-card
                  class="border mb-0"
                >
                  <b-card-text class="card-text content-heading">
                    <p style="float: right">
                      {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                    </p>
                  </b-card-text>
                  <b-card-text class="card-text content-heading">
                    <h4>Debtia: {{ data.content != null ? JSON.parse(data.content).name : '' }}</h4>
                    <p>
                      <b-link
                        class="mt-75"
                      >
                        <feather-icon icon="MailIcon" /> {{ $t('DEBTIA_DISPATCHED') }} </b-link> : {{ data.sent_at }}
                    </p>
                    <b-link
                      v-if="data.letter_file.length > 0"
                      :href="data.letter_file"
                      target="_blank"
                      class="mt-75"
                    ><span class="text-muted font-weight-bolder align-text-top">{{ data.letter_file.substring(data.letter_file.lastIndexOf("/")+1) }} <feather-icon
                      icon="ExternalLinkIcon"
                    /></span>
                    </b-link>
                    <div
                      v-if="data.attachments != null && data.attachments.length > 0 && data.attachments !== '[]'"
                      class="border mb-10 padding-content"
                    >
                      <div
                        class="business-item"
                      >
                        <div
                          class="d-flex flex-column"
                        >
                          <b-link
                            v-for="(value, index) in JSON.parse(data.attachments)"
                            :key="index"
                            :href="value"
                            target="_blank"
                            :class="{'mt-75': index}"
                          >
                            <span class="text-muted font-weight-bolder align-text-top">{{ value.substring(value.lastIndexOf("/")+1) }} <feather-icon
                              icon="ExternalLinkIcon"
                            /></span>
                          </b-link>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-card>
              </div>
              <div
                v-else
              >
                <b-card
                  class="border mb-0"
                >
                  <b-card-text class="card-text content-heading mb-35">
                    <h4>
                      {{ data.title }}
                    </h4> <p style="float: right">
                      {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                    </p>
                  </b-card-text>
                  <div
                    id="collapse-1-inner"
                    class="mt-2 content-container"
                  >
                    <div class="border mb-10 padding-content">
                      <div class="note-content-div">
                        {{ data.note }}
                      </div>
                    </div>
                  </div>
                  <app-collapse
                    accordion
                  >
                    <app-collapse-item
                      v-if="data.content.length > 0"
                      :title="$t('DEBTIA_SEE_CONTENT')"
                    >
                      <b-card class="border mb-0">
                        <prism
                          language="javascript"
                          class="rounded"
                        >
                          {{ JSON.stringify(JSON.parse(data.content), null, 2) }}
                        </prism>
                      </b-card>
                    </app-collapse-item>
                  </app-collapse>
                </b-card>
              </div>
            </div>
          </b-card>
          <case-details-modal
            :case-data="showData"
            :selected-state="selectedState"
            :case-state="caseState"
            :b-title="bTitle"
            :b-varient="bVarient"
            :modal-loads="modalLoader"
            :show="!modalLoader"
            :reload-method="getDetails"
            :reason-options="reasonOptions"
          />
          <b-popover
            v-if="!loader"
            ref="popover"
            target="popover-reactive-1"
            triggers="hover"
            placement="auto"
            container="my-container"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-center">
                <span>Client Details</span>
              </div>
            </template>
            <table
              class="client-details-table"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_USERNAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.username }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.name }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_EMAIL') }}</td>
                <td class="right-values item-padding">
                  <a :href="'mailto:' + currentHoverClient.email">{{ currentHoverClient.email }}</a>
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PHONE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.phone }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_LOGIN') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.loginStatus === '1' ? 'Allowed' : 'Not Allowed' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_BILLING_EMAIL') }}</td>
                <td class="right-values item-padding">
                  <a :href="'mailto:' + currentHoverClient.billing_email">{{ currentHoverClient.billing_email ? currentHoverClient.billing_email : 'N/A' }}</a>
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CONTACT_PERSON') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.contact_person ? currentHoverClient.contact_person : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CLIENT_TYPE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.type ? currentHoverClient.type : 'N/A' }}
                </td>
              </tr>
            </table>
            <table
              :class="currentHoverClient.billing_address ? '' : 'table-border'"
              class="client-addressdetails-table"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  <h5>{{ $t('DEBTIA_ADDRESS') }}</h5></td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.house_number ? currentHoverClient.address.house_number : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ROAD_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.road_name ? currentHoverClient.address.road_name : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PLACE_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.place ? currentHoverClient.address.place : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ZIP_CODE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.zip_code ? currentHoverClient.address.zip_code : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CITY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.city ? currentHoverClient.address.city : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_COUNTRY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.country ? currentHoverClient.address.country : 'N/A' }}
                </td>
              </tr>
            </table>
            <table
              v-if="currentHoverClient.billing_address"
              class="client-addressdetails-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  <h5>{{ $t('DEBTIA_BILLING_ADDRESS') }}</h5></td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address ? currentHoverClient.billing_address.house_number : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ROAD_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.road_name ? currentHoverClient.billing_address.road_name : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PLACE_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.place ? currentHoverClient.billing_address.place : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ZIP_CODE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.zip_code ? currentHoverClient.billing_address.zip_code : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CITY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.city ? currentHoverClient.billing_address.city : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_COUNTRY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.country ? currentHoverClient.billing_address.country : 'N/A' }}
                </td>
              </tr>
            </table>
            <b-button
              v-if="$ability.can(constants.action.permissionClientEdit, constants.resource.client)"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :to="{ name: 'client-view', params: { id: currentHoverClient.id } }"
              target="_blank"
              class="edit-client-btn"
            >
              {{ $t("DEBTIA_VIEW_MORE") }}
              <feather-icon
                icon="ExternalLinkIcon"
              />
            </b-button>
          </b-popover>
          <b-popover
            v-for="(data, debtorindex) in caseData.debtors"
            :key="'d-'+debtorindex"
            ref="popover"
            :target="'popover-reactive-debtor-'+data.id"
            triggers="hover"
            placement="auto"
            container="my-container"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-center">
                <span>Debtor Details</span>
              </div>
            </template>
            <table
              class="client-details-table"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_USERNAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.username }}
                </td>
              </tr>

              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.name }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_EMAIL') }}</td>
                <td class="right-values item-padding">
                  <a :href="'mailto:' + currentHoverDebtor.email">{{ currentHoverDebtor.email }}</a>
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PHONE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.phone ? currentHoverDebtor.phone : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_LOGIN') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.loginStatus === '1' ? 'Allowed' : 'Not Allowed' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_SELECT_CLIENT') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.client_id ? currentHoverDebtor.client_id : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CONTACT_PERSON') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.contact_person ? currentHoverDebtor.contact_person : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_DEBTOR_TYPE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.debtor_type ? currentHoverDebtor.debtor_type : 'N/A' }}
                </td>
              </tr>
              <tr
                v-if="currentHoverDebtor.debtor_type !== 'person'"
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CVRCPR') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.cvr_number ? currentHoverDebtor.cvr_number : 'N/A' }}
                </td>
              </tr>
              <tr
                v-if="currentHoverDebtor.debtor_type === 'person'"
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_BIRTHDATE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.birthdate ? currentHoverDebtor.birthdate : 'N/A' }}
                </td>
              </tr>
            </table>
            <table
              v-if="currentHoverDebtor.address"
              class="client-addressdetails-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  <h5>{{ $t('DEBTIA_ADDRESS') }}</h5></td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.house_number ? currentHoverDebtor.address.house_number : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ROAD_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.road_name ? currentHoverDebtor.address.road_name : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PLACE_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.place ? currentHoverDebtor.address.place : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ZIP_CODE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.zip_code ? currentHoverDebtor.address.zip_code : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CITY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.city ? currentHoverDebtor.address.city : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_COUNTRY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.country ? currentHoverDebtor.address.country : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_COURT') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.court_id && currentHoverDebtor.address.court_id > 0 ? currentHoverDebtor.address.court.name : 'N/A' }}
                </td>
              </tr>
            </table>
            <b-button
              v-if="$ability.can(constants.action.permissionDebtorEdit, constants.resource.debtor)"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :to="{ name: 'debtor-view', params: { id: currentHoverDebtor.id } }"
              target="_blank"
              class="edit-client-btn"
            >
              {{ $t("DEBTIA_VIEW_MORE") }}
              <feather-icon
                icon="ExternalLinkIcon"
              />
            </b-button>
          </b-popover>
          <b-popover
            v-for="(data,index) in caseData.debtors"
            :key="index"
            ref="popover"
            :target="'popover-reactive-representative-'+data.id"
            triggers="hover"
            placement="auto"
            container="my-container"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-center">
                <span>Representative Details</span>
              </div>
            </template>
            <table
              class="client-details-table"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.name }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_EMAIL') }}</td>
                <td class="right-values item-padding">
                  <a :href="'mailto:' + currentHoverRepresentative.email">{{ currentHoverRepresentative.email }}</a>
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PHONE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.phone ? currentHoverRepresentative.phone : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CONTACT_PERSON') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.company ? currentHoverRepresentative.company : 'N/A' }}
                </td>
              </tr>
            </table>
            <table
              v-if="currentHoverRepresentative.representative_address"
              class="client-addressdetails-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  <h5>{{ $t('DEBTIA_ADDRESS') }}</h5></td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.house_number ? currentHoverRepresentative.representative_address.house_number : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ROAD_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.road_name ? currentHoverRepresentative.representative_address.road_name : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PLACE_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.place ? currentHoverRepresentative.representative_address.place : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ZIP_CODE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.zip_code ? currentHoverRepresentative.representative_address.zip_code : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CITY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.city ? currentHoverRepresentative.representative_address.city : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_COUNTRY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.country ? currentHoverRepresentative.representative_address.country : 'N/A' }}
                </td>
              </tr>
            </table>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :to="{ name: 'debtor-view', params: { id: currentHoverRepresentative.debtor_id } }"
              target="_blank"
              class="edit-client-btn"
            >
              {{ $t("DEBTIA_VIEW_MORE") }}
              <feather-icon
                icon="ExternalLinkIcon"
              />
            </b-button>
          </b-popover>
          <b-popover
            v-if="!loader"
            ref="popover"
            target="popover-reactive-3"
            triggers="hover"
            placement="auto"
            container="my-container"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-center">
                <span>Representative Details</span>
              </div>
            </template>
            <table
              class="client-details-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_USERNAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.username }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.name }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_EMAIL') }}</td>
                <td class="right-values item-padding">
                  <a :href="'mailto:' + currentHoverEmployee.email">{{ currentHoverEmployee.email }}</a>
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PHONE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.phone }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ADDRESS') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.address ? currentHoverEmployee.address : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_LOGIN') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.loginStatus === '1' ? 'Allowed' : 'Not Allowed' }}
                </td>
              </tr>
            </table>
          </b-popover>
          <b-popover
            v-if="!loader"
            ref="popover"
            target="popover-reactive-4"
            triggers="hover"
            placement="auto"
            container="my-container"
            variant="danger"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-centers">
                <span v-if="caseDetailsData.status === 2">{{ $t('DEBTIA_CASE_DECLINED_BECAUSE') }}</span>
                <span v-if="caseDetailsData.status === 3">{{ $t('DEBTIA_CASE_TERMINATED_BECAUSE') }}</span>
              </div>
            </template>
            <table
              class="client-details-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_REASON') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverStateData.reason }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_DESCRIPTION') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverStateData.description }}
                </td>
              </tr>
            </table>
          </b-popover>
        </b-col>
      </b-row>
      <terminate-data-modal
        ref="terminateModal"
        :case-data="showData"
        :case-state-title="caseStateTitle"
        :modal-loads="loader"
        :show="!loader"
        :reload-method="getDetails"
        :reason-options="reasonOptions"
      />
      <bailiff-modal
        ref="bailiffmodal"
        :case-id="Number(caseId)"
        :reload-method="getDetails"
        :switch-loader="switchLoader"
      />
      <agreement-link-modal
        :journal-id="journalId"
        :case-id="caseId"
        :main-debtor-email="mainDebtorEmail"
        :main-debtor-phone="mainDebtorPhone"
        :modal-click-trigger="modalClickTrigger"
      />
      <base-documents-modal
        :base-documents-categories="baseDocumentsCategories"
        :base-document-templates="baseDocumentTemplates"
        :selected-base-documents="selectedBaseDocuments"
        :all-base-documents="allBaseDocuments"
        :check-all="checkAll"
        :refresh-checkboxes="refreshCheckboxes"
      />
      <other-files-modal
        :case-id="caseId"
        :get-details="getDetails"
      />
      <change-client-modal
        :case-id="caseId"
        :creditor-id="creditorId"
        :get-details="getDetails"
        :get-debt-case-debtors="caseDebtors"
        :client-debtors-options="clientDebtorsOptions"
      />
      <change-debtors-model
        :case-id="caseId"
        :creditor-id="creditorId"
        :get-details="getDetails"
        :get-debt-case-debtors="caseDebtors"
        :client-debtors-options="clientDebtorsOptions"
      />
      <case-process-change
        :case-id="caseId"
        :current-process-id="currentProcessID"
        :get-details="getDetails"
      />
      <edit-statements-modal
        :case-id="caseId"
        :modal-loads="loader"
        :show="!loader"
        :click-change="editStatementModalClicked"
        :get-details="getDetails"
        :statements-amount="statementsAmount"
        :show-bailif-checkbox="showBailifCheckbox"
        :bailif-value="bailifValue"
        :disable-bailif="disableBailif"
        :set-general-loader="setGeneralLoader"
      />
      <b-modal
        id="user-action-modal"
        ref="user-action-modal"
        centered
        title="Button Action"
        ok-title="Submit"
        :no-close-on-backdrop="true"
        cancel-variant="outline-secondary"
        @show="resetModal"
        @hidden="resetModal"
        @ok="validationButtonForm"
      >
        <b-overlay
          id="overlay-background"
          :show="btnloader"
          variant="dark"
          opacity="0.85"
          blur="2px"
          rounded="sm"
          spinner-variant="primary"
          spinner-medium
        >
          <validation-observer ref="buttonRules">
            <b-form>
              <b-alert
                v-if="buttonError"
                variant="warning"
                show
              >
                <div class="alert-body">
                  {{ buttonError }}
                </div>
              </b-alert>
              <b-row>
                <b-col
                  sm="12"
                >
                  <b-form-group
                    :label="$t('DEBTIA_DESCRIPTION')"
                    label-for="description"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Description"
                      rules="required"
                    >
                      <b-form-textarea
                        id="textarea-rows"
                        v-model="description"
                        :placeholder="$t('DEBTIA_DESCRIPTION')"
                        rows="8"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                >
                  <b-form-group
                    :label="$t('DEBTIA_FILE')"
                    label-for="description"
                    class="mb-2"
                  >
                    <validation-provider
                      v-slot="{ validate, errors }"
                      name="File"
                      rules="required"
                    >
                      <b-form-file
                        id="file-default"
                        ref="button-file"
                        @change="validate($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-overlay>
      </b-modal>
    </b-overlay>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BButtonGroup,
  BTable,
  BOverlay,
  BCardTitle,
  VBToggle,
  BCardText,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BListGroup,
  BListGroupItem,
  BBadge,
  BAvatar,
  BLink,
  VBPopover,
  BCardHeader,
  BMediaBody,
  BMedia,
  BMediaAside,
  BCardBody,
  BPopover,
  BBreadcrumb,
  BBreadcrumbItem,
  BFormFile,
  BFormTextarea,
  BForm,
  BAlert,
  BFormCheckbox,
} from 'bootstrap-vue'
// slint-disable-next-line vue/no-unused-components
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import router from '@/router'
import axios from '@axios'
import i18n from '@/libs/i18n'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { quillEditor } from 'vue-quill-editor'
import CaseDetailsModal from './CaseDetailsModal.vue'
import TerminateDataModal from './TerminateDataModal.vue'
import AgreementLinkModal from './AgreementLinkModal.vue'
import BaseDocumentsModal from './BaseDocumentsModal.vue'
import OtherFilesModal from './OtherFilesModal.vue'
import BailiffModal from './details/childcomponents/BailiffModal.vue'
import CaseProcessChange from './CaseProcessChange.vue'
import EditStatementsModal from './EditStatementsModal.vue'
import CaseCustomVariables from './CaseCustomVariables.vue'
import ChangeClientModal from './ChangeClientModal.vue'
import ChangeDebtorsModel from './ChangeDebtorsModal.vue'
// import EditClientModal from './EditClientModal.vue'
// import EditDebtorModal from './EditDebtorModal.vue'
// import EditRepresentativeModal from './EditRepresentativeModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    CaseDetailsModal,
    TerminateDataModal,
    BTable,
    BOverlay,
    BCardTitle,
    BButtonGroup,
    // EditClientModal,
    // EditDebtorModal,
    // EditRepresentativeModal,
    BCardText,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BListGroup,
    BListGroupItem,
    AppCollapse,
    AppCollapseItem,
    Prism,
    BBadge,
    BAvatar,
    BLink,
    BCardHeader,
    BMediaBody,
    BMedia,
    BMediaAside,
    BCardBody,
    BPopover,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BBreadcrumb,
    BBreadcrumbItem,
    AgreementLinkModal,
    BForm,
    BFormFile,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BAlert,
    vSelect,
    quillEditor,
    CaseCustomVariables,
    OtherFilesModal,
    ChangeClientModal,
    ChangeDebtorsModel,
    EditStatementsModal,
    CaseProcessChange,
    BailiffModal,
    // CaseEvents,
    BFormCheckbox,
    BaseDocumentsModal,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      header_check: false,
      courts: [],
      customVariables: [],
      notesbusy: false,
      installmentloader: false,
      btnloader: false,
      required,
      caseData: {},
      caseClientData: {},
      caseDebtors: [],
      caseTaskActionData: {},
      caseDetailsData: {},
      documentsData: [],
      caseStateData: [],
      statementsAmount: [],
      statementsData: [],
      costStatementsData: [],
      costStatementsData1: [],
      collectionFeesData: [],
      compansationFeesData: [],
      reminderDocumentsData: [],
      collectionCostsData: [],
      paymentsData: [],
      clients: [],
      id: 0,
      snowOption: {
        theme: 'snow',
        modules: {
          toolbar: [],
        },
      },
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      user_role: JSON.parse(localStorage.getItem('userData')).role[0],
      apiBody: '',
      pdfLink: '',
      name: '',
      reason: '',
      state: '',
      description: '',
      companyname: '',
      busy: false,
      showData: {},
      selectedState: '',
      caseState: '',
      caseStateTitle: '',
      bTitle: '',
      bVarient: '',
      modalLoader: true,
      loader: false,
      upHere: false,
      // clientsObj: [],
      isHovered: false,
      caseId: 0,
      creditorId: 0,
      value: 'Some value',
      caseLogsData: [],
      caseStatements: [],
      perPage: 1000000,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      isBlur: false,
      activeClass: 'active',
      errorClass: '',
      currentHoverClient: {
        address: {},
        billing_address: {},
      },
      currentHoverDebtor: {
        address: {},
      },
      currentHoverRepresentative: {
        address: {},
      },
      customVariableAirports: [],
      currentHoverEmployee: {},
      currentHoverStateData: {},
      constants,
      isSuperAdmin: false,
      journalId: '',
      mainDebtorEmail: '',
      mainDebtorPhone: '',
      modalClickTrigger: false,
      buttonDescription: '',
      buttonError: '',
      clickedBtn: 0,
      processId: 0,
      installmentData: [],
      installmentplanstatus: 404,
      noteRoles: [],
      selectedRoles: [],
      notestext: '',
      invoicesData: [],
      showNotesAlert: false,
      caseProcessesCompleted: 0,
      isInstallmentPlanCompleted: 0,
      defaultCurrency: localStorage.getItem('defaultCurrency'),
      currentProcessID: 0,
      clientDebtorsOptions: [],
      debt_case_state: null,
      editStatementModalClicked: false,
      generalLoader: false,
      baseDocumentVariables: {},
      selectedBaseDocuments: [],
      selectedDeletableDocuments: [],
      baseDocumentsCategories: [],
      baseDocumentTemplates: [],
      allBaseDocuments: [],
      processedLetters: [],
      baseDocumentType: 1,
      checkAll: false,
      documentLoader: false,
      processedLettersCheck: false,
      showBailifCheckbox: false,
      bailifValue: false,
      disableBailif: false,
    }
  },
  setup() {
    const reasonOptions = []
    const reasonOptionsArgs = []
    const requestArgs = [
      { request: '/get-reason-options', param: 'reasonOptions' },
    ]
    return {
      reasonOptions,
      reasonOptionsArgs,
      requestArgs,
    }
  },
  computed: {
    classObject() {
      return {
        active: this.isBlur,
        style: 'filter: blur(1px); pointer-events: none;',
      }
    },
    documentsTableFields() {
      return [
        { key: 'checkbox' },
        { key: 'action', sortable: true, label: i18n.t('DEBTIA_ACTION') },
        {
          key: 'category', sortable: true, label: i18n.t('DEBTIA_CATEGORY_TEMPLATE'), tdClass: 'text-capitalize',
        },
        { key: 'title', sortable: true, label: i18n.t('DEBTIA_TITLE') },
        { key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK') },
        { key: 'payment_amount', sortable: true, label: i18n.t('DEBTIA_PAYMENT_AMOUNT') },
        { key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'paid_amount', sortable: true, label: i18n.t('DEBTIA_PAID_AMOUNT') },
        { key: 'interest_rate_percentage', sortable: true, label: i18n.t('DEBTIA_INTEREST_RATE') },
        { key: 'document_due_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_DUE_DATE') },
        { key: 'document_send_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_SENT_DATE') },
      ]
    },
    statementsTableFields() {
      return [
        { key: 'category', label: '', tdClass: 'text-left' },
        { key: 'total_amount', label: i18n.t('DEBTIA_TOTAL_AMOUNT'), tdClass: 'text-right' },
        { key: 'paid_amount', label: i18n.t('DEBTIA_PAID_AMOUNT'), tdClass: 'text-right' },
        { key: 'rest_amount', label: i18n.t('DEBTIA_REST_AMOUNT'), tdClass: 'text-right' },
      ]
    },
    statementBaseDocumentsTableFields() {
      return [
        { key: 'file_link', label: '-', tdClass: 'text-left' },
        { key: 'total_amount', label: '-', tdClass: 'text-right' },
        { key: 'paid_amount', label: '-', tdClass: 'text-right' },
        { key: 'rest_amount', label: '-', tdClass: 'text-right' },
      ]
    },
    statementCostDocumentsTableFields() {
      return [
        { key: 'jobTaskNo', label: '-', tdClass: 'text-left' },
        { key: 'total_amount', label: '-', tdClass: 'text-right' },
        { key: 'paid_amount', label: '-', tdClass: 'text-right' },
        { key: 'rest_amount', label: '-', tdClass: 'text-right' },
      ]
    },
    paymentsTableFields() {
      return [
        { key: 'id', label: '' },
        { key: 'payment_date', label: i18n.t('DEBTIA_PAYMENT_DATE') },
        { key: 'amount', label: i18n.t('DEBTIA_AMOUNT') },
        { key: 'remaining_amount', label: i18n.t('DEBTIA_REMAINING_AMOUNT') },
      ]
    },
    installmentTableFields() {
      return [
        { key: 'installment_date', label: i18n.t('DEBTIA_INSTALLMENT_DATE') },
        { key: 'interest', label: i18n.t('DEBTIA_INSTALLMENT_INTEREST') },
        { key: 'amount', label: i18n.t('DEBTIA_AMOUNT') },
        { key: 'remaining_amount', label: i18n.t('DEBTIA_REMAINING_AMOUNT') },
        { key: 'status', label: i18n.t('DEBTIA_STATUS') },
      ]
    },
    paymentsDataTableFields() {
      return [
        { key: 'category', label: '-' },
        { key: 'payment_date', label: '-' },
        { key: 'total_amount', label: '-' },
      ]
    },
    invoicesTableFields() {
      return [
        { key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK') },
        { key: 'payment_id', label: i18n.t('DEBTIA_PAYMENT_ID'), tdClass: 'text-right' },
        { key: 'sub_total', label: i18n.t('DEBTIA_SUB_TOTAL'), tdClass: 'text-right' },
        { key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'total_amount', label: i18n.t('DEBTIA_TOTAL_AMOUNT'), tdClass: 'text-right' },
      ]
    },
  },
  watch: {
    baseDocumentType: {
      handler() {
        this.documentLoader = true
        this.allBaseDocuments = []
        if (this.selectedBaseDocuments.length > 0) {
          this.selectedBaseDocuments.forEach(element => {
            this.baseDocumentVariables[`checkbox_${element}`].check = false
          })
        }
        setTimeout(() => {
          this.getCurrentBaseDocuments(this.baseDocumentType)
          this.documentLoader = false
        }, 500)
      },
    },
    header_check: {
      handler() {
        this.baseDocumentsCategories = []
        this.baseDocumentTemplates = []
        this.selectedBaseDocuments = []
        this.selectedDeletableDocuments = []
        Object.keys(this.baseDocumentVariables).forEach(element => {
          this.baseDocumentVariables[element].check = this.header_check
          this.categoryCheck(this.header_check, this.baseDocumentVariables[element].id, this.baseDocumentVariables[element].category, this.baseDocumentVariables[element].template_id, this.baseDocumentVariables[element].template_name, this.baseDocumentVariables[element].debt_stage)
          if (this.header_check) {
            this.selectedBaseDocuments.push(this.baseDocumentVariables[element].id)
            if (this.baseDocumentVariables[element].category !== 'Base Documents'
            && this.baseDocumentVariables[element].category !== 'Credit Notes'
            && this.baseDocumentVariables[element].category !== 'Debt Reminders'
            && this.baseDocumentVariables[element].category !== 'Processed Letters'
            && this.baseDocumentVariables[element].category !== null) {
              this.selectedDeletableDocuments.push(this.baseDocumentVariables[element].id)
            }
          }
        })
      },
    },
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0 && this.searchRun) {
          this.searchRun = false
          this.currentPage = 1
          this.getCaseLogsData()
        }
      },
    },
    currentPage: {
      handler() {
        this.getCaseLogsData()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getCaseLogsData()
      },
    },
  },
  created() {
    this.loader = true
    this.setStatementsTranslations()
    this.getNoteRoles()
    this.getReasons()
    this.getDetails()
    this.isSuperAdminFunction()
    this.getCourtsDropdown()
  },
  methods: {
    changeBtn() {
      this.editStatementModalClicked = !this.editStatementModalClicked
    },
    refreshCheckboxes() {
      // this.baseDocumentVariables.checkbox_5924.check = false
      if (this.header_check) {
        this.header_check = false
      } else if (this.selectedBaseDocuments.length > 0) {
        this.documentLoader = true
        this.allBaseDocuments = []
        setTimeout(() => {
          this.getCurrentBaseDocuments(this.baseDocumentType)
          this.documentLoader = false
        }, 500)
      }
      this.selectedBaseDocuments = []
      this.selectedDeletableDocuments = []
    },
    deleteConfirmationPopup() {
      let titles = ''
      this.selectedDeletableDocuments.forEach(element => {
        titles += `${this.baseDocumentVariables[`checkbox_${element}`].title}<br>`
      })
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: i18n.t('DEBTIA_SURE_REVERT_MSG'),
        icon: 'warning',
        html:
          `${i18n.t('DEBTIA_FILE_DELETION_MSG')}: <br>${titles}${i18n.t('DEBTIA_SURE_REVERT_MSG')}`,
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES_DELETE_IT_1'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteFiles()
        }
      })
    },
    async deleteFiles() {
      const filesData = []
      this.selectedBaseDocuments.forEach(element => {
        const filteredObj = this.allBaseDocuments.filter(documentelement => element === documentelement.id)
        filesData.push(filteredObj[0])
      })
      const obj = {
        debt_case_id: this.caseId,
        ids: this.selectedDeletableDocuments,
        files_data: filesData,
      }
      await axios.post('/delete-debt-case-file', obj).then(responseLocal => {
        if (responseLocal.status) {
          this.refreshCheckboxes()
          this.getDetails()
          this.processedLetters = []
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            text: i18n.t('DEBTIA_FILE_DELETION_MSG'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      }).catch(err => {
        this.loader = false
        this.alertErrors = [...err.response.data.message]
      })
    },
    downloadAllFiles() {
      this.baseDocumentsCategories = []
      this.baseDocumentTemplates = []
      Object.keys(this.baseDocumentVariables).forEach(element => {
        this.categoryCheck(true, this.baseDocumentVariables[element].category_id, this.baseDocumentVariables[element].category, this.baseDocumentVariables[element].template_id, this.baseDocumentVariables[element].template_name, this.baseDocumentVariables[element].debt_stage)
      })
    },
    downloadSelectedFiles() {
      this.baseDocumentsCategories = []
      this.baseDocumentTemplates = []
      this.selectedBaseDocuments.forEach(element => {
        this.categoryCheck(true, this.baseDocumentVariables[`checkbox_${element}`].category_id, this.baseDocumentVariables[`checkbox_${element}`].category, this.baseDocumentVariables[`checkbox_${element}`].template_id, this.baseDocumentVariables[`checkbox_${element}`].template_name, this.baseDocumentVariables[`checkbox_${element}`].debt_stage)
      })
    },
    capitalizeWords(str) {
      return str.replace(/\b\w/g, char => char.toUpperCase())
    },
    baseDocumentCheckBoxClicked(value, id) {
      if (value) {
        this.selectedBaseDocuments.push(id)
        if (this.baseDocumentVariables[`checkbox_${id}`].category !== 'Base Documents'
          && this.baseDocumentVariables[`checkbox_${id}`].category !== 'Credit Notes'
          && this.baseDocumentVariables[`checkbox_${id}`].category !== 'Debt Reminders'
          && this.baseDocumentVariables[`checkbox_${id}`].category !== 'Processed Letters'
          && this.baseDocumentVariables[`checkbox_${id}`].category !== null) {
          this.selectedDeletableDocuments.push(id)
        }
      } else {
        // to remove the checkbox id
        const indexToRemove = this.selectedBaseDocuments.indexOf(id)
        if (indexToRemove !== -1) {
          this.selectedBaseDocuments.splice(indexToRemove, 1)
        }
        const deleteIndexToRemove = this.selectedDeletableDocuments.indexOf(id)
        if (deleteIndexToRemove !== -1) {
          this.selectedDeletableDocuments.splice(deleteIndexToRemove, 1)
        }
      }
    },
    categoryCheck(check, categoryId, categoryName, templateId, templateName, debtStage) {
      if (categoryName === 'Base Documents' || categoryName === 'Credit Notes' || categoryName === 'Debt Reminders' || categoryName === 'Processed Letters') {
        const foundCategory = this.baseDocumentsCategories.findIndex(item => item.id === categoryId && item.name === categoryName)
        const obj = {
          id: categoryId,
          name: categoryName,
          debt_stage: debtStage,
        }
        if (check && foundCategory === -1) {
          this.baseDocumentsCategories.push(obj)
        }
        // to remove the checkbox category
        if (!check && foundCategory !== -1) {
          this.baseDocumentsCategories.splice(foundCategory, 1)
        }
      }
      if (categoryId) {
        const foundCategory = this.baseDocumentsCategories.findIndex(item => item.id === categoryId)
        const obj = {
          id: categoryId,
          name: categoryName,
          debt_stage: debtStage,
        }
        if (check && foundCategory === -1) {
          this.baseDocumentsCategories.push(obj)
        }
        // to remove the checkbox category
        if (!check && foundCategory !== -1) {
          this.baseDocumentsCategories.splice(foundCategory, 1)
        }
      }
      if (templateId) {
        const foundTemplate = this.baseDocumentTemplates.findIndex(item => item.id === templateId)
        // const categoryToRemove = this.baseDocumentsCategories.indexOf(this.capitalizeWords(category))
        const obj = {
          id: templateId,
          name: templateName,
          debt_stage: debtStage,
        }
        if (check && foundTemplate === -1) {
          this.baseDocumentTemplates.push(obj)
        }
        // to remove the checkbox category
        if (!check && foundTemplate !== -1) {
          this.baseDocumentTemplates.splice(foundTemplate, 1)
        }
      }
    },
    switchLoader() {
      this.loader = true
    },
    getFormatedDate(value) {
      const currentDate = new Date(value)
      // Define the date format options
      const dateFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }

      // Format the date
      const formattedDate = new Intl.DateTimeFormat('en-US', dateFormatOptions).format(currentDate)
      return formattedDate
    },
    confirmDeleteDocument(id, title, fileLink) {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: `${i18n.t('DEBTIA_DELETING_FILE_TEXT')} ${title}. ${i18n.t('DEBTIA_REVERT_MSG')}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const obj = {
            debt_case_id: this.caseId,
            files_data: [
              {
                debt_stage: 'letter_files',
                link: fileLink,
              },
            ],
            ids: [id],
          }
          axios.post('/delete-debt-case-file', obj).then(response => {
            if (response.status === 200) {
              if (response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: '',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.loader = true
                this.getDetails()
              }
            }
          })
        }
      })
    },
    setStatementsTranslations() {
      axios.get('settings/get-statement-settings').then(translationResponse => {
        for (const [lang, trans] of Object.entries(translationResponse.data.data.translations)) {
          i18n.mergeLocaleMessage(lang, trans)
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    async getCourtsDropdown() {
      await axios.get('settings/courts/dropdown')
        .then(response => {
          this.courts = response.data.data
        }).catch(() => false)
    },
    getNoteRoles() {
      axios.get('/users/get-user-roles').then(response => {
        if (response.status === 200) {
          this.noteRoles = response.data.data
          this.selectedRoles = this.noteRoles
        }
      })
    },
    getTitle(role) {
      const entry = this.noteRoles.filter(record => record.value === role)
      let title = 'N/A'
      if (entry[0]) {
        title = entry[0].label
      }
      return title
    },
    canshow(contents) {
      let exists = false
      if (contents) {
        const arr = JSON.parse(contents)
        arr.forEach(element => {
          if (element === this.user_role) {
            exists = true
          }
        })
      }
      return exists
    },
    async setStrLimit(id, action) {
      if (action === 'more') {
        if (this.caseLogsData.length > 0) {
          this.caseLogsData.forEach((element, index) => {
            if (element.id === id) {
              this.caseLogsData[index].isOpen = true
            }
          })
        }
      }
      if (action === 'less') {
        if (this.caseLogsData.length > 0) {
          this.caseLogsData.forEach((element, index) => {
            if (element.id === id) {
              this.caseLogsData[index].isOpen = false
            }
          })
        }
      }
    },
    notesfieldsfilled() {
      this.$refs.addnotesform.validate().then(success => {
        if (success) {
          this.notesbusy = true
          const roles = []
          this.selectedRoles.forEach(x => roles.push(x.value))
          const obj = {
            debt_case_id: this.caseId,
            note: this.notestext,
            roles,
          }
          axios.post('/add-debt-case-note', obj).then(response => {
            if (response.status === 200) {
              const newObj = {
                id: response.data.data.note.id,
                title: 'Debt Case Notes',
                type: 'Debt Case Notes',
                note: this.notestext,
                content: JSON.stringify(roles),
                en_log_created_at: response.data.data.note.en_log_created_at,
                da_log_created_at: response.data.data.note.da_log_created_at,
              }
              this.notesbusy = false
              this.notestext = ''
              this.showNotesAlert = true
              setTimeout(() => {
                this.showNotesAlert = false
              }, 10000)
              this.caseLogsData.unshift(newObj)
              this.$refs.addnotesform.reset()
            }
          })
        }
      })
    },
    confirmText() {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: i18n.t('DEBTIA_REVERT_MSG'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.installmentloader = true
          axios.post(`${constants.paymentsBaseUrl}/installment_plan/update_status`, {
            journal_id: Number(this.caseId),
            status: -1,
          }).then(response => {
            if (response.status === 200) {
              this.installmentloader = false
              this.installmentplanstatus = 3
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: i18n.t('DEBTIA_PLAN_CANCELLATION_SUCCESS'),
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.getInstallmentPlan()
            }
          })
        }
      })
    },
    async getInstallmentPlan() {
      await axios.get(`${constants.paymentsBaseUrl}/installment_plan/get_installments?journal_id=${this.caseId}`).then(response => {
        if (response.status) {
          this.installmentData = response.data.data.installments_data
          this.installmentplanstatus = response.data.data.plan_status
        }
      }).catch(() => {
        this.installmentData = []
        this.installmentplanstatus = 404
      })
    },
    formatCurrency(amount, defaultCurrency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    actionBtnClicked(id, processId) {
      this.clickedBtn = id
      this.processId = processId
    },
    userActionButtonClicked(buttonId, processId) {
      this.loader = true
      const caseId = this.$route.params.id
      const form = new FormData()
      form.append('process_id', processId)
      form.append('button_id', buttonId)
      form.append('case_id', caseId)
      const url = '/process/case/run-button-module'
      axios.post(url, form).then(response => {
        if (response.status === 200) {
          // this.loader = false
          this.getDetails()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'Action performed on button.',
            },
          })
        }
      })
    },
    copyCode(id) {
      let codeToCopy = ''
      if (id === 'copy-bc-case-id') {
        codeToCopy = document.querySelector(`#${id}`)
      }
      if (id === 'copy-case-id') {
        codeToCopy = document.querySelector(`#${id}`)
      }
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()
      try {
        document.execCommand('copy')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Text copied',
            icon: 'BellIcon',
          },
        })
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failed to copy texts!',
            icon: 'BellIcon',
          },
        })
      }
      /* unselect the range */
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    openGenerateAgreementForm() {
      this.modalClickTrigger = !this.modalClickTrigger
    },
    isSuperAdminFunction() {
      if (this.user_type === 'super-admin') {
        this.isSuperAdmin = true
      } else {
        this.isSuperAdmin = false
      }
    },
    // setrepresentativepopup(employee) {
    //   this.currentHoverEmployee = employee
    // },
    setdebtorpopup(debtor) {
      this.currentHoverDebtor = debtor
    },
    setpopup(client) {
      this.currentHoverClient = client
    },
    setStatePopup(data) {
      this.currentHoverStateData = data
    },
    setrepresentativepopup(representative) {
      this.currentHoverRepresentative = representative
    },
    async getReasons() {
      try {
        await Promise.all(
          this.requestArgs
            .map(REQUEST => axios
              .get(REQUEST.request)
              .then(res => {
                if (REQUEST.param === 'reasonOptions') {
                  this.reasonOptions = [...res.data.data]
                }
              })),
        )
          .then(() => {
            this.loading = false
          })
      } catch (error) {
        console.log('options error', error)
      }
    },
    // async getClients() {
    //   this.loader = true
    //   await axios.get('clients/dropdown')
    //     .then(response => {
    //       this.loader = false
    //       this.clientsObj.push(...response.data.data)
    //     }).catch(error => {
    //       console.log(error)
    //     })
    // },
    getBtnVariant(variant) {
      const btncolor = variant.includes('#') ? 'relief-primary' : `relief-${variant.toLowerCase()}`
      return btncolor
    },
    async openLink(href) {
      window.open(href, '_blank')
    },
    setGeneralLoader() {
      this.generalLoader = true
    },
    makeVariableForBaseDocuments(documents) {
      this.baseDocumentVariables = {}
      this.selectedBaseDocuments = []
      this.selectedDeletableDocuments = []
      documents.forEach(element => {
        this.baseDocumentVariables[`checkbox_${element.id}`] = {
          id: element.id,
          check: false,
          category: element.category ? this.capitalizeWords(element.category) : null,
          category_id: element.category_id,
          debt_stage: element.debt_stage,
          title: element.title,
          template_name: element.template_name,
          template_id: element.template_id,
        }
      })
    },
    async getDetails() {
      this.caseId = router.currentRoute.params.id
      // this.loader = true
      const caseDetails = await axios.get(`${constants.baseUrl}/get-debt-case/${this.caseId}`).catch(error => {
        if (error.response.status === 404) {
          this.$router.push('/cases')
        }
      })
      if (caseDetails.status) {
        this.customVariables = caseDetails.data.data.custom_variables
        this.customVariableAirports = caseDetails.data.data.options
        this.journalId = caseDetails.data.data.debt_case.bc_case_id
        const processCase = caseDetails.data.data.process_cases ? caseDetails.data.data.process_cases : []
        this.isInstallmentPlanCompleted = caseDetails.data.data.is_installment_plan_completed
        this.currentProcessID = processCase.length > 0 ? caseDetails.data.data.process_cases[0].process_id : 0
        this.caseProcessesCompleted = processCase.length > 0 ? caseDetails.data.data.process_cases[0].completed : 0
        const processModule = processCase.length > 0 && caseDetails.data.data.process_cases[0].process_module ? [caseDetails.data.data.process_cases[0].process_module] : []
        if (!this.caseProcessesCompleted && processModule.length > 0 && caseDetails.data.data.process_cases[0].process_module.module_id === 17) this.$refs.bailiffmodal.$children[0].show()
        this.getInstallmentPlan()
        if (caseDetails.data.data.debt_case_state !== null && typeof caseDetails.data.data.debt_case_state !== 'undefined') {
          this.caseStateData = caseDetails.data.data.debt_case_state
          this.state = caseDetails.data.data.debt_case_state.state
          // if (this.state === 'terminate') {
          //   this.isBlur = true
          //   this.getTerminateData(this.caseStateData, 'terminate')
          // }
        } else {
          this.caseStateData.debt_case_id = this.caseId
        }
        if (caseDetails.data.data !== null) {
          this.caseData = { ...caseDetails.data.data }
          this.caseClientData = { ...caseDetails.data.data.client }
          this.creditorId = caseDetails.data.data.client.id
          this.getDebtorsOptions(this.creditorId)
          this.caseDebtors = caseDetails.data.data.case_debtors
          // breadcrumbItems
          this.caseDetailsData = this.caseData.debt_case
          this.mainDebtorEmail = this.caseData.debtors[0].email
          this.mainDebtorPhone = this.caseData.debtors[0].phone
          if (this.caseDetailsData.status === 2) {
            this.isBlur = true
            this.getTerminateData(this.caseStateData, 'decline')
          } else if (this.caseDetailsData.status === 3) {
            this.isBlur = true
            this.getTerminateData(this.caseStateData, 'terminate')
          } else {
            this.isBlur = false
          }
          this.caseStateData.creditor_id = (caseDetails.data.data.client) ? caseDetails.data.data.client.id : 0
          this.caseStateData.remaining_debt_amount = (caseDetails.data.data.remainingDebtAmount) ? caseDetails.data.data.remainingDebtAmount : 0
          this.caseLogsData = caseDetails.data.data.get_logs
          // this.caseLogsData = []
          this.statementsData = []
          this.documentsData = []
          this.costStatementsData = []
          this.costStatementsData1 = []
          this.statementsAmount = []
          this.caseStatements = caseDetails.data.data.statements
          this.invoicesData = caseDetails.data.data.invoices
          const headingData = Object.keys(caseDetails.data.data)
          this.headingArray = headingData
          let newObj = null
          let statementGroups = null
          const baseDocumentsData = []
          const paymentDocumentsData = []
          // let baseDocTotal = 0
          let baseDocPaid = 0
          let principalPaid = caseDetails.data.data.statements[1].paidAmount
          const defaultCurrency = typeof caseDetails.data.data.debt_case.default_currency !== 'undefined' ? caseDetails.data.data.debt_case.default_currency : 'DKK'
          this.defaultCurrency = defaultCurrency
          headingData.forEach(element => {
            if (element === 'base_documents' || element === 'credit_notes' || element === 'debt_reminders' || element === 'other_files') {
              newObj = caseDetails.data.data[element]
              newObj.forEach(key => {
                if (typeof key.file_link !== 'undefined') {
                  const objArr = []
                  objArr.id = key.id
                  objArr.category = (key.category === '' || typeof key.category === 'undefined') ? element.replace('_', ' ') : key.category
                  objArr.category_id = key.category_id
                  objArr.debt_stage = element
                  objArr.file_link = key.file_link
                  objArr.title = (key.title) ? key.title : '-'
                  objArr.payment_amount = (key.payment_amount) ? new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.payment_amount).toFixed(2)) : '-'
                  objArr.vat_amount = (key.vat_amount) ? new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.vat_amount).toFixed(2)) : '-'
                  objArr.paid_amount = (key.paid_amount) ? new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.paid_amount).toFixed(2)) : '-'
                  objArr.interest_rate_percentage = key.interest_rate_percentage
                  objArr.interest_rate_agreed = key.interest_rate_agreed
                  objArr.default_interest_rate = (key.interest_rate_agreed) ? key.interest_rate_percentage : key.interest_rate_percentage
                  objArr.document_due_date = (key.document_due_date) ? key.document_due_date : '-'
                  objArr.document_send_date = (key.document_send_date) ? key.document_send_date : '-'
                  objArr.template_name = null
                  objArr.template_id = null
                  objArr.processedLettersCheck = false
                  if (element === 'credit_notes') {
                    objArr.payment_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.credit_note_amount).toFixed(2))
                  }
                  if (element === 'debt_reminders') {
                    objArr.payment_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format((parseFloat(key.compensation_fee) + parseFloat(key.reminder_fee)).toFixed(2))
                  }
                  this.documentsData.push(objArr)
                  if (element === 'base_documents') {
                    objArr.id = key.id
                    objArr.file_link = key.file_link
                    objArr.total_amount = key.payment_amount + key.vat_amount
                    objArr.rest_amount = key.payment_amount + key.vat_amount - key.paid_amount
                    // add paid principal to base doc paid amount
                    let docPaidAmount = parseFloat(key.paid_amount)
                    let docRestAmount = parseFloat(objArr.rest_amount)
                    if (principalPaid > parseFloat(objArr.rest_amount)) {
                      docPaidAmount += parseFloat(objArr.rest_amount)
                      principalPaid -= parseFloat(objArr.rest_amount)
                    } else {
                      docPaidAmount += parseFloat(principalPaid)
                      principalPaid = 0
                    }
                    docRestAmount = key.payment_amount + key.vat_amount - parseFloat(docPaidAmount)
                    objArr.total_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(objArr.total_amount).toFixed(2))
                    // objArr.paid_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(parseFloat(key.paid_amount).toFixed(2))
                    objArr.paid_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(docPaidAmount).toFixed(2))
                    // objArr.rest_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(parseFloat(objArr.rest_amount).toFixed(2))
                    objArr.rest_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(docRestAmount).toFixed(2))
                    baseDocumentsData.push(objArr)

                    // baseDocTotal += parseFloat(key.payment_amount) + parseFloat(key.vat_amount)
                    baseDocPaid = parseFloat(baseDocPaid) + parseFloat(key.paid_amount)
                  }
                  if (element === 'credit_notes') {
                    objArr.id = key.id
                    objArr.file_link = key.file_link
                    objArr.total_amount = 0
                    objArr.total_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(objArr.total_amount).toFixed(2))
                    objArr.paid_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.credit_note_amount).toFixed(2))
                    objArr.rest_amount = 0 - key.credit_note_amount
                    objArr.rest_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(objArr.rest_amount).toFixed(2))
                    baseDocumentsData.push(objArr)

                    baseDocPaid += parseFloat(key.credit_note_amount)
                  }
                }
              })
            }
            if (element === 'statements') {
              const statementsKeysRow = []
              statementGroups = caseDetails.data.data[element]
              statementGroups.forEach(statementGroupValue => {
                const newGroup = {}
                newGroup.en_name = statementGroupValue.en_name
                newGroup.da_name = statementGroupValue.da_name
                newGroup.category = (i18n.locale === 'en') ? statementGroupValue.en_name : statementGroupValue.da_name
                newGroup.total_amount = new Intl.NumberFormat('da-DK', {
                  style: 'currency',
                  currency: defaultCurrency,
                }).format(parseFloat(statementGroupValue.totalAmount).toFixed(2))
                newGroup.paid_amount = new Intl.NumberFormat('da-DK', {
                  style: 'currency',
                  currency: defaultCurrency,
                }).format(parseFloat(statementGroupValue.paidAmount).toFixed(2))
                newGroup.rest_amount = new Intl.NumberFormat('da-DK', {
                  style: 'currency',
                  currency: defaultCurrency,
                }).format(parseFloat(statementGroupValue.restAmount).toFixed(2))
                if (typeof statementGroupValue.statements !== 'undefined') {
                  const costDocuments = []
                  Object.values(statementGroupValue.statements).forEach(key => {
                    const objArr = {}
                    if (caseDetails.data.data.statementKeys.includes(key.jobTaskNo)) {
                      objArr.en_name = key.en_name
                      objArr.da_name = key.da_name
                      objArr.category = (i18n.locale === 'en') ? key.en_name : key.da_name
                      objArr.jobTaskNo = key.jobTaskNo
                      // baseDocPaid += parseFloat(key.paidAmount)
                      objArr.total_amount = new Intl.NumberFormat('da-DK', {
                        style: 'currency',
                        currency: defaultCurrency,
                      }).format(parseFloat(key.scheduleTotalPrice).toFixed(2))
                      paymentDocumentsData.push(objArr)
                      objArr.paid_amount = new Intl.NumberFormat('da-DK', {
                        style: 'currency',
                        currency: defaultCurrency,
                      }).format(parseFloat(key.paidAmount).toFixed(2))
                      objArr.rest_amount = key.scheduleTotalPrice - key.paidAmount
                      objArr.rest_amount = new Intl.NumberFormat('da-DK', {
                        style: 'currency',
                        currency: defaultCurrency,
                      }).format(parseFloat(objArr.rest_amount).toFixed(2))
                      costDocuments.push(objArr)
                      if (!statementsKeysRow.includes(key.jobTaskNo)) {
                        statementsKeysRow.push(key.jobTaskNo)
                        this.statementsAmount.push(key)
                      }
                    }
                  })
                  newGroup.costDocuments = costDocuments
                } else if (statementGroupValue.en_name !== 'Sum' || statementGroupValue.da_name !== 'Sum') {
                  const defaultStatementLine = {}
                  defaultStatementLine.en_name = statementGroupValue.en_name
                  defaultStatementLine.da_name = statementGroupValue.da_name
                  defaultStatementLine.jobTaskNo = statementGroupValue.jobTaskNo
                  defaultStatementLine.scheduleTotalPrice = statementGroupValue.totalAmount
                  defaultStatementLine.paidAmount = statementGroupValue.paidAmount
                  this.statementsAmount.push(defaultStatementLine)
                }
                this.statementsData.push(newGroup)
              })
            }
            if (element === 'payments') {
              newObj = caseDetails.data.data[element]
              newObj.forEach(key => {
                const objArr = []
                objArr.id = key.entryNo
                objArr.payment_date = key.dueDate
                objArr.amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.Amount).toFixed(2))
                objArr.remaining_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.remainingAmount).toFixed(2))
                objArr.documents = paymentDocumentsData
                this.paymentsData.push(objArr)
              })
            }
          })
        }
        this.generalLoader = false
        this.showBailifCheckbox = caseDetails.data.data.show_bailif_ability
        // eslint-disable-next-line no-unneeded-ternary
        this.bailifValue = caseDetails.data.data.bailif_checkbox === true ? false : true
        // eslint-disable-next-line no-unneeded-ternary
        this.disableBailif = caseDetails.data.data.bailif_checkbox === true ? false : true
        this.generalLoader = false
        this.loader = false
        this.addProcessedLettersForBaseDocuments(caseDetails.data.data.letter_files)
        this.getCurrentBaseDocuments(1)
        this.makeVariableForBaseDocuments(this.allBaseDocuments)
      }
    },
    addProcessedLettersForBaseDocuments(letters) {
      this.processedLetters = []
      letters.forEach(element => {
        const obj = {
          id: element.id,
          category: null,
          category_id: null,
          debt_stage: 'letter_files',
          title: element.file_name,
          file_link: element.file_link,
          default_interest_rate: '',
          document_due_date: '',
          document_send_date: '',
          interest_rate_agreed: '',
          interest_rate_percentage: '',
          paid_amount: '',
          payment_amount: '',
          rest_amount: '',
          total_amount: '',
          vat_amount: '',
          template_name: element.title,
          template_id: element.letter_template_id,
          processedLettersCheck: true,
        }
        this.processedLetters.push(obj)
      })
    },
    getCurrentBaseDocuments(type) {
      this.header_check = false
      if (type === 2) {
        this.allBaseDocuments = [...this.documentsData]
      } else if (type === 3) {
        this.allBaseDocuments = [...this.processedLetters]
      } else {
        this.allBaseDocuments = [...this.documentsData, ...this.processedLetters]
      }
      this.makeVariableForBaseDocuments(this.allBaseDocuments)
    },
    getDebtorsOptions(id) {
      const url = `/debtor/dropdown?client_id=${id}`
      axios.get(url).then(response => {
        if (response.status === 200) {
          response.data.data.forEach(element => {
            const objArr = {}
            objArr.value = element.value
            objArr.label = `${element.label.slice(0, 30)}...`
            this.clientDebtorsOptions.push(objArr)
          })
        }
      })
    },
    async debtCaseAction(id, status) {
      await axios.post(`${constants.baseUrl}/approve-debt-case`, {
        debt_case_id: id,
        status,
      }).then(response => {
        if (response.status === 200) {
          this.getDetails()
        }
      })
    },
    async getDebtCaseActionData(item, state) {
      if (state === 'decline') {
        this.caseState = 'Decline'
        this.bTitle = this.$t('DEBTIA_DECLINE_CASE')
        this.bVarient = 'danger'
      }
      if (state === 'terminate') {
        this.caseState = 'Terminate'
        this.bTitle = this.$t('DEBTIA_TERMINATE_CASE')
        this.bVarient = 'danger'
      }
      if (state === 'pause') {
        this.caseState = 'Pause'
        this.bTitle = this.$t('DEBTIA_PAUSE_CASE')
        this.bVarient = 'warning'
      }
      if (state === 'resume') {
        this.caseState = 'Resume'
        this.bTitle = this.$t('DEBTIA_RESUME_CASE')
        this.bVarient = 'primary'
      }
      this.modalLoader = true
      this.showData = { ...item }
      if (state === 'pause' || state === 'terminate' || state === 'decline') {
        this.showData.description = ''
      }
      this.selectedState = (state === 'decline') ? 'terminate' : state
      this.modalLoader = false
    },
    async getTerminateData(item, state) {
      if (state === 'terminate') {
        this.caseStateTitle = this.$t('DEBTIA_CASE_TERMINATED_BECAUSE')
      }
      if (state === 'decline') {
        this.caseStateTitle = this.$t('DEBTIA_CASE_DECLINED_BECAUSE')
      }
      this.$refs.terminateModal.$children[0].show()
      this.modalLoader = true
      this.showData = { ...item }
      this.modalLoader = false
    },
    async getClientData(item) {
      this.$refs.clientModal.$children[0].show()
      this.loader = true
      this.showData = item
      this.showData.debt_case_id = this.caseId
      this.loader = false
    },
    async getDebtorData(item) {
      this.$refs.debtorModal[0].$children[0].show()
      this.loader = true
      this.showData = item
      this.loader = false
    },
    async hideDebtorData(item) {
      this.$refs['modal-debtor'].hide()
      this.loader = false
      this.showData = item
      this.loader = true
    },
    async getRepresentativeData(item) {
      this.$refs.representativeModal.$children[0].show()
      this.loader = true
      this.showData = item
      this.showData.debt_case_id = this.caseId
      this.loader = false
    },
    async getCaseLogsData() {
      this.caseId = router.currentRoute.params.id
      this.loader = true
      const caseLogs = await axios.get(`${constants.baseUrl}/get-debt-case-logs/${this.caseId}?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}`)
      if (caseLogs.data.status) {
        this.caseLogsData = caseLogs.data.data.data
      }
      this.loader = false
    },
    validationButtonForm(evt) {
      evt.preventDefault()
      this.$refs.buttonRules.validate().then(success => {
        const caseId = this.$route.params.id
        const file = this.$refs['button-file'].files[0]
        const form = new FormData()
        form.append('process_id', this.processId)
        form.append('description', this.description)
        form.append('button_id', this.clickedBtn)
        form.append('case_id', caseId)
        form.append('file_proof', file)
        if (success) {
          this.btnloader = true
          const url = '/process/case/run-button-module'
          axios.post(url, form).then(response => {
            if (response.status === 200) {
              this.btnloader = false
              this.$router.go()
            }
          })
        }
      })
    },
    resetModal() {
      this.buttonDescription = ''
      this.buttonError = ''
    },
  },
}
</script>

<style lang="scss">

.casedetails-card-body {
  border-bottom: 1px solid #f2f3f3;
}

.right-values{
  float: right;
}

.left-item-padding {
  padding: 0px 20px 0px 0px;
}

.edit-client-btn {
  width: 100%;
  margin-bottom: 10px;
}

.client-details-table {
  width: 100%;
  margin: 10px 0px 10px 0px;
  padding-top: 15px;
  border-top: 1px solid #f2f3f3;
}

.client-addressdetails-table {
  width: 100%;
  margin: 10px 0px 10px 0px;
}

.table-border {
  border-bottom: 1px solid #f2f3f3;
}

// table.child-table td:last-child,
// table.child-table-base td:last-child {
//     padding-right: 0;
// }
// table.child-table td:nth-child(1) {
//     padding-left: 0;
//     width: 0%;
// }
// table.child-table-base td:nth-child(1) {
//     padding-left: 0;
//     width: 15%;
// }
// table.child-table-base td:nth-child(2) {
//     width: 32%;
// }
// table.child-table-base td:nth-child(3) {
//     width: 28%;
// }
// table.child-table td:nth-child(2) {
//     width: 23% !important;
// }
// table.child-table td:nth-child(3) {
//     width: 28% !important;
// }
#debt-statements table td, #debt-statements table th {
  width: 25%;
  padding: 0.72rem 1rem;
}
#debt-statements .parent-table th {
  text-align: right;
}
#debt-statements .child-table-base,
#debt-statements .child-table {
  padding-left: 0;
  padding-right: 0;
}

#debt-statements .child-table a {
  font-size: 10px;
}
#debt-statements td[colspan="4"] {
    padding: 0;
}
.text-capitalize {
  text-transform: 'capitalize'
}
.popover {
  min-width: 400px;
}

.pointer-name:hover {
  cursor: pointer;
}
.copy-btn:hover {
  cursor: pointer;
}
.representative-div {
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px solid #d9d9d9;
}
.user-action-buttons {
  margin-top: 20px;
}

.user-action-button {
  margin-bottom: 10px;
  width: 100%;
}

.installment-plan-header {
  padding: 0px !important;
  margin-bottom: 15px;
}

.installment-plan-body{
  padding: 0px;
}

.notesSubmitBtn {
  width: 100%
}

.padding-content {
  padding: 10px;
}

.content-heading {
  margin-bottom: 0px !important;
}

.note-content-div {
  display: inline-block; width: 93%; min-height: 38px;
}

.note-font {
  font-size: 14px;
  margin-right: 10px;
}

.notes-alert{
  margin-top: 10px;
}

@import '@core/scss/vue/libs/quill.scss';
.ql-container.ql-snow{
  height: 150px !important;
}

.note-font p{
  margin-bottom: 0px !important;
}

.ql-toolbar.ql-snow {
  display: none !important;
}

.ql-container.ql-snow{
  border-top: 1px solid #d8d6de !important;
}

.processcompletedmessage, .processcompletedmessagealert {
  margin-bottom: 0px !important;
}

.base-document-header {
  padding-left: 0px !important;
  padding-top: 0px !important;
}

.case-general-info-blue {
  border: 1px solid #48a4ff !important;
}

.case-general-info-red {
  border: 1px solid red !important;
}

.case-general-info-green {
  border: 1px solid #219289 !important;
}

.case-general-info-orange {
  border: 1px solid orange !important;
}

.case-general-info-yellow {
  border: 1px solid yellow !important;
}

.display-inline {
  display: inline-block;
}

.mb-35 {
  margin-bottom: 35px !important;
}
/* Styles for the icon box */
.b-avatar .b-avatar-custom, .b-avatar .b-avatar-text, .b-avatar .b-avatar-img {
    -webkit-mask-image: none;
    // mask-image: radial-gradient(white, black);
}
.star-icon-box:before {
    content: '';
}
.star-icon-box {
  position: relative;
  // width: 100px;
  // height: 100px;
  // background-color: #f0f0f0;
  // border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Styles for the star */
.star {
  position: absolute;
  top: 0;
  // left: 0;
  left: -7px;
  top: -8px;;
  width: 20px;
  height: 20px;
  background-color: gold;
  clip-path: polygon(
      50% 0%,
      61% 38%,
      100% 38%,
      68% 59%,
      79% 100%,
      50% 75%,
      21% 100%,
      32% 59%,
      0% 38%,
      39% 38%
    );
  }
  .document-buttons {
    margin-right: 5px;
  }

  .base-document-active-btn {
    background-color: #b6d6d3;
  }

  .padding-1 {
    padding: 1px !important;
  }

  .swal2-html-container {
    text-align: left !important;
    padding: 20px;
    border: 1px solid #c7c7c7;
    border-radius: 10px;
  }
</style>
